import { EnvironmentProviders, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    RippleModule,
    StyleClassModule,
    InputTextModule, // TODO: Temporary imported. Remove when corresponding custom component is implemented
  ],
})
export class OspUiModule {
  static forRoot(providers?: Array<Provider | EnvironmentProviders>): ModuleWithProviders<OspUiModule> {
    return {
      ngModule: OspUiModule,
      providers: [...(providers ?? [])],
    };
  }
}
